export const iconFontAwesomeHumanitarianPlugCircleXmark = (
	<i className="fa-solid fa-plug-circle-xmark"></i>
);
